<template>
  <div v-if="!isDisabled" class="category_prices_block">
    <h2>
      {{ title }}
    </h2>
    <div v-if="loading" class="category_prices_block__preloader">
      <Preloader />
    </div>
    <table v-else>
      <thead>
        <tr>
          <th>{{ headline }}</th>
          <th>{{ $t('categoryPricesBlockPriceTh') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="product in products" :key="product.slug">
          <td>
            <router-link :to="productPath(product)">
              {{ productTitle(product) }}
            </router-link>
          </td>
          <td>
            {{
              $t('categoryPricesBlockPrice', {
                price: product.newPrice || product.price,
              })
            }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
// import { mapActions, mapMutations, mapState } from 'vuex'
import { mapState, mapActions } from 'vuex'
import Preloader from '@/components/Preloader'
import categoryFiltersMixin from '@/components/category/categoryFiltersMixin'

export default {
  name: 'PricesBlock',
  mixins: [categoryFiltersMixin],
  components: {
    Preloader,
  },
  data() {
    return {
      isDisabled: false,
      loading: true,
      products: [],
    }
  },
  computed: {
    ...mapState(['headline', 'lang', 'categories']),
    title() {
      return this.$t('categoryPricesBlockTitle', {
        title: this.headline,
      })
    },
  },
  beforeMount() {
    this.isDisabled = false
  },
  methods: {
    ...mapActions(['fetchCategoryPricesBlock']),
    productPath(product) {
      const cc = `${product.childCategory}`
      let refPath = `${product.parentCategory}/${cc.replace(',', '/')}`
      let path = ''
      let chain = refPath.split('/')
      let _c = this.categories
      chain.forEach((p) => {
        if (!_c) return
        let c = _c.find((c) => c.id === p)
        if (c) {
          _c = c.children || null
          if (path !== '') path += '/'
          path += c.slug
        }
      })
      const productPathChain = [this.lang || '', 'product', path, product.slug]
      return `${this.lang ? '/' : ''}${productPathChain.join('/')}`
    },
    productTitle(product) {
      const { locale } = this.$i18n

      return product[`name_${locale}`] || product.name || ''
    },
    getSize(key) {
      const [sizeStr, id] = key.match(/[a-zA-Z]+|[0-9]+/g)
      let size = Number(sizeStr)
      switch (id) {
        case 'tb':
          size = size * 1000
          break
        case 'mb':
          size = size / 1000
          break
        default:
          break
      }
      return size
    },
    sortMemories({ options }) {
      const sortedOptions = options.sort(
        (a, b) => this.getSize(b.slug) - this.getSize(a.slug)
      )
      return sortedOptions
    },
    getPath(memory) {
      const isUsed = /used/m.test(this.$route.path)
      let pathChain = [
        '/category/',
        isUsed
          ? this.category.currentPath.replace(/used\//, '')
          : this.category.currentPath,
        `?memory=${memory.slug}${
          isUsed ? '&new-or-used=yes' : ''
        }&order=price_asc&limit=1000`,
      ]

      return pathChain.join('')
    },
    async fetchPricesBlock(sortedMemories) {
      const response = await this.fetchCategoryPricesBlock(
        this.getPath(sortedMemories.pop())
      )

      if (response && response.products) {
        return response.products
      } else {
        if (sortedMemories.length) {
          return await this.fetchPricesBlock(sortedMemories)
        }
      }
    },
    async initBlock() {
      this.loading = true
      try {
        const memories = this.categoryFilters.find(
          ({ slug }) => slug === 'memory'
        )
        if (memories) {
          const sortedMemories = this.sortMemories(memories)
          const products = await this.fetchPricesBlock(sortedMemories)

          if (products) {
            this.products = products
            this.isDisabled = false
          } else {
            this.isDisabled = true
          }
        } else {
          this.isDisabled = true
        }
      } catch (error) {
        console.log('[initBlock]', error)
        this.isDisabled = true
      } finally {
        this.loading = false
      }
    },
  },
  mounted() {
    if (!this.isDisabled) {
      this.initBlock()
    }
  },
}
</script>

<style>
.category_prices_block__preloader {
  position: relative;
  min-height: 200px;
}
</style>
